export default "__VITE_ASSET__C5COyIxa__"